import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';

import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { UsersSelectComponent } from '@wilson/non-domain-specific/account/account-helpers';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzRadioModule } from 'ng-zorro-antd/radio';

@Component({
  selector: 'wilson-export-zip-qualifications-v2-modal',
  imports: [
    TranslatePipe,
    NzRadioModule,
    NzButtonModule,
    FormsModule,
    UsersSelectComponent,
  ],
  templateUrl: './export-zip-qualifications-v2-modal.component.html',
  styleUrl: './export-zip-qualifications-v2-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportZipQualificationsV2ModalComponent {
  userId = '';
  @Output() userIdChange = new EventEmitter<string>();

  onUserIdChange(userId: string): void {
    this.userId = userId;
    this.userIdChange.emit(userId);
  }
}
